import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';

export default function MemberPay() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('memberToken');
    if (!token) {
      navigate('/member-portal/login');
    }
  }, [navigate]);

  return (
    <Box>
      <Container maxWidth="sm" sx={{ mb: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <PaymentIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Payment Temporarily Disabled
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Mobile money payment is currently unavailable. Please check back later or contact your association for alternative payment options.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/member-portal')}>
            Back to Dashboard
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
